import React from "react";

function PrivacyModal({ isOpen, onClose }) {
  if (!isOpen) return null;
  return (
    <div className="modal-overlay" style={{color:"black" ,position: 'fixed', top:0, left:0, width:'100vw', height:'100vh', background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000}}>
      <div className="modal-content" style={{ padding:'2rem', borderRadius:'8px', minWidth:'300px', maxWidth:'90vw', maxHeight:'90vh', overflowY:'auto'}}>
        <button onClick={onClose} style={{float:'right', fontSize:'1.2rem', border:'none', background:'none', cursor:'pointer'}}>×</button>
        <h2>Privacy Policy</h2>
        <div style={{marginTop:'1rem'}}>
          <p>Your privacy is important to us. This policy explains how Weekly Pickem collects, uses, and protects your information:</p>
          <ul>
            <li>We collect basic user data for account creation and site functionality.</li>
            <li>Your data is never sold or shared with third parties except as required by law.</li>
            <li>Cookies may be used to enhance your experience.</li>
            <li>We use industry-standard security measures to protect your data.</li>
            <li>You may request deletion of your account and data at any time.</li>
            <li>Contact us at weeklypickem25@gmail.com for privacy concerns.</li>
          </ul>
          <p>By using Weekly Pickem, you consent to this privacy policy.</p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyModal;
